import { getImageObject, getLayerRecolorEnabled } from '../utils';

export function ImageLayerHandler(
  resAst: Ast,
  layerAst: Ast,
  layer: StoreLayerItem,
  colors: StoreThemeColorItem[]
) {
  layer.attrs.resources = {
    pointer0: getImageObject(resAst, layerAst.attrsMap.name, colors)
  };
  layer.attrs.recolorEnable = getLayerRecolorEnabled(
    resAst,
    layerAst.attrsMap.name
  );
  layer.attrs = { ...layerAst.attrsMap, ...layer.attrs };
}
